export const environment = {
  production: false,
  apiUrl: null as string | null, // No API access in preview mode
  isPreviewMode: true,
  allowedOrigins: [
    'https://app.availme.net',
    'https://appdev.slotscout.net',
    'https://app.dev.availme.net',
    'https://dev.slotscout.net',
    'https://localhost:4200',
  ],
};
